import apiClient from './apiClient';

// Notification subscriptions — Phase B of the event-notification system.
// See docs/adrs/0001-notification-subscriptions.md in the API repo.
//
// Endpoints (defined in serverless-portfolio-tracker
// src/handlers/subscriptionsHandler.js):
//   GET    /subscriptions
//   POST   /subscriptions
//   PATCH  /subscriptions/:id    (enabled toggle only — MVP)
//   DELETE /subscriptions/:id
//
// Subscription shape returned by GET / POST:
//   { subscriptionId, userId, eventTypeId, customEventId | null,
//     timeframes, symbols, channels, quietHours | null,
//     dedupeWindowMinutes | null, enabled, createdAt, updatedAt }

export const listSubscriptions = async () => {
  const response = await apiClient.get('/subscriptions');
  return response.data?.subscriptions || [];
};

export const createSubscription = async (input) => {
  const response = await apiClient.post('/subscriptions', input);
  return response.data?.subscription;
};

export const setSubscriptionEnabled = async (subscriptionId, enabled) => {
  const response = await apiClient.patch(
    `/subscriptions/${encodeURIComponent(subscriptionId)}`,
    { enabled },
  );
  return response.data?.subscription;
};

export const deleteSubscription = async (subscriptionId) => {
  await apiClient.delete(`/subscriptions/${encodeURIComponent(subscriptionId)}`);
};
